import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';

export const tiposRestauranteApi = `${baseApi}/restaurant-types`;

export const getAllTiposRestauranteService = async (params) => {
  // params.active = true;
  const res = await axios.get(tiposRestauranteApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveTiposRestauranteService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.put(`${tiposRestauranteApi}/${id}`, data, {
      headers: await token({}),
    });
  } else {
    res = await axios.post(`${tiposRestauranteApi}`, data, {
      headers: await token({}),
    });
  }
  return res.data;
};

export const getOneTiposRestauranteService = async (id) => {
  const res = await axios.get(`${tiposRestauranteApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteTiposRestauranteService = async (id) => {
  const res = await axios.delete(`${tiposRestauranteApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};
